export default "__VITE_ASSET__Bod2Tb2P__"